<template>
	<div class="wrap container">
    <router-view name="head"></router-view>
    <router-view class='animated slideInRight'></router-view>
    <div class="fixed_right">
      <div class="fixed_item">
        <img src="/static/images/qq.png" alt="" class="fimg">
      </div>
      <div class="fixed_item wechatcode">
        <img src="/static/images/wechat.png" alt="" class="fimg">
        <img src="/static/images/code.jpg" alt="" class="wxcode">
      </div>
      <div class="fixed_item" @click='gotop'>
        <img src="/static/images/arrow_t.png" alt="" class="fimg">
      </div>
    </div>
		<router-view name="foot"></router-view>
	</div>
</template>
<script>
import animatecss from 'animate.css'
export default {  
  name: 'app',  
  data () {  
    return {  
      
    }  
  },  
  mounted () {  
  },
  watch: {  
   
  },
  methods:{
    gotop(){
      $("html,body").animate({scrollTop:0});
    }
  } 

}  
</script>
<style>
 .common_mbx{
    padding: 38px 0 33px 0;
    font-size: 14px;
    color: #383838;
    width: 1200px;
    margin: 0 auto;
  }
  .common_mbx span{
    cursor: pointer;
  }
  .fixed_right{
    width: 54px;
    position: fixed;
    right: 40px;
    bottom: 20%;
  }
  .fixed_item{
    height: 54px;
    border-radius: 4px;
    border:1px solid #ebebeb;
    margin-bottom: 4px;
    background-color: #ffffff;
    position: relative;
    cursor: pointer;
  }
  .fixed_item:last-child{
    margin-bottom: 0;
  }
  .fimg{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .wxcode{
    width: 114px;
    max-width: 114px;
    position: absolute;
    left: -120px;
    top: -30px;
    display: none;
  }
  .wechatcode:hover .wxcode{
    display: block;
  }
  div.hot_item{
    position: relative;
    top: 0;
    transition: all 0.5s;
  }
  div.hot_item:hover{
    transition: all 0.5s;
    top: -10px;
    box-shadow: 2px 2px 20px #e4e4e4;
  }
</style>


// WEBPACK FOOTER //
// src/components/public/main.vue